import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

//swiperまるごとセット
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.mvslide();
        this.mvSwiper();
        this.bnrSwiper();
    }

    mvslide() {
        const triggers = [...document.querySelectorAll(".js-mvslide")];

        triggers.forEach((el) => {
            el.addEventListener("click", () => {
                triggers.forEach((el) => el.classList.remove("-active"));
                el.classList.add("-active");
            });
        });
    }

    mvSwiper() {
        const swiper = new Swiper(".mv_swiper", {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 0,
            speed: 500,

            autoplay: {
                delay: 5000,
            },

            navigation: {
                nextEl: ".mv_swiper-button-next",
                prevEl: ".mv_swiper-button-prev",
            },
        });
    }

    bnrSwiper() {
        const option = {
            autoplay: { delay: 5000 },
            loop: true,
            pagination: { el: ".swiper-pagination", clickable: true },
        };

        const swiper = new Swiper(".slidebnr__cont", option);
    }
}
